/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type EntityCombobox_viewer = {
    readonly linkedEntities: ReadonlyArray<{
        readonly type: string;
        readonly name: string | null;
        readonly account: string | null;
    }>;
    readonly " $refType": "EntityCombobox_viewer";
};
export type EntityCombobox_viewer$data = EntityCombobox_viewer;
export type EntityCombobox_viewer$key = {
    readonly " $data"?: EntityCombobox_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"EntityCombobox_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "entityReference"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "EntityCombobox_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "entityReference",
          "variableName": "entityReference"
        }
      ],
      "concreteType": "LinkedEntity",
      "kind": "LinkedField",
      "name": "linkedEntities",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "account",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '38dd026ee34520f4c39864e83a6a61bf';
export default node;
